/* ------------------------------------------------------------------------ */
/*		File: cmpMenu.tsx                                                   */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

import React, { useContext } from "react";
import { ICard } from "./cmpMenu.d";
import "./cmpMenu.css"
import Button from "../GenericComponents/Button";
import Group from "../cmpGroup/cmpGroup";
import { useChatbot } from "../../context/ChatbotContext";
import { useNavigate } from "react-router-dom";

/* ------------------------------------------------------------------------ */


const Menu: React.FC<ICard> = (props) => {
    const navigate = useNavigate();
    const { isOpened, setIsOpened } = useChatbot();

    return (
        <div className="card_menu">
            <div className="card_menu_title">{props.label}</div>
            <div className="card_menu_options">
                {props.options?.map((item:any, index:any) => (
                    <div key={`div-${index}`}  className="card_menu_option">
                        <div className="card_menu_option bullet"/>
                        <div className="card_menu_option text">
                            <a 
                                key={`menu-${index}`}    
                                className="card_menu_option"
                                onClick={() => item.navigateTo.includes("symy") ? setIsOpened(true) : navigate(`${item.navigateTo}`)}
                            >
                                {item.label}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            {props.buttons !== null && props.buttons!.length > 0 && props.buttons!.map((item:any, index:any) => (
                <div key={`div2-${index}`} className="card_menu_button">
                        <Button 
                            key={`menu-button-${index}`}
                            classProp={`${item.color}-button`}
                            label={item.label}
                            hasIcon={item.src !== null}
                            src={item.src !== null ? item.src : "transparent.svg"}
                            size={"medium"}
                            //textColor={colorType.BLUE}
                            onClick={() => item.navigateTo.includes("symy") ? setIsOpened(true) : navigate(`${item.navigateTo}`)}
                        />
                </div>
            ))}

            {props.quotation !== null && (
                <div className="card_menu_quotation">
                    <div className="card_menu_description">{props.quotation!.description}</div>
                    <div className="card_menu_author">{props.quotation!.author}</div>
                </div>
            )}

            <div className="group_container">
                {props.hasOwnProperty("groups") && props.groups !== null && (
                    <Group
                        card={props.groups!}
                    />
                )}

            </div>
                
        </div>
    );
};
export default Menu; 